import { getContactlist, delContactList, importContact } from '@/services/edm'

export default {
  namespaced: true,
  state: {
    columns: [{
      title: '邮箱',
      dataIndex: 'email',
      width: 320
    }, {
      title: '联系人',
      dataIndex: 'name',
      slots: { title: 'name' },
      scopedSlots: { customRender: 'name' },
      width: 280
    },
    {
      title: '添加时间',
      dataIndex: 'addtime',
      scopedSlots: { customRender: 'addtime' },
      width: 280
    },
    {
      title: '状态',
      dataIndex: 'status',
      slots: { title: 'status' },
      scopedSlots: { customRender: 'status' },
      width: 80
    }],
    listDatas: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    },
    loading: true,
    contactName: '',
    importContactResult: {
      failNum: 0,
      successNum: 0,
      failArr: ''
    }
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_TOTAL (state, total) {
      state.pagination.total = total
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_CONTACT_NAME (state, data) {
      state.contactName = data
    },
    SET_CONTACT_IMPORT (state, data) {
      state.importContactResult.failNum = data.fail
      state.importContactResult.successNum = data.success
      state.importContactResult.failArr = data.failArr.split(/↵|\n|\r|\r\n|' | '/g) || []
    }
  },
  getters: {
    columns (state) {
      const { defaultColumns } = state
      defaultColumns.forEach(item => {
        if (item.sorter) {
          item.sortOrder = state.sortedInfo.columnKey === item.dataIndex && state.sortedInfo.order
        }
      })
      return defaultColumns
    }
  },
  actions: {
    async fetchContactlist ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getContactlist()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess(res => {
          commit('setListDatas', res.list)
          commit('SET_TOTAL', res.count)
          commit('SET_LOADING', false)
          commit('SET_CONTACT_NAME', res.contactname)
        })
        .fetch()
      return chain
    },
    async delContactList ({ commit }, params) {
      let chain = await delContactList()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async importContact ({ commit }, params) {
      let chain = await importContact()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess(res => {
          commit('SET_CONTACT_IMPORT', res)
        })
        .fetch()
      return chain
    }
  }
}
